import type { Schema } from '../../Entities/Schema.entity';
import { createSchema } from '../../Utils/CreateSchema';

export const wholesaleSearchFiltersSchema: Schema = {
  ...createSchema({
    version: '1-3-0',
    description: 'Filters for wholesale vehicle listing searches',
    name: 'wholesale_search_filters',
    properties: {
      auction_grade: {
        type: 'array',
        items: { type: 'string' },
        description:
          'Allows filtering based on the grade (condition) of a vehicle. From 1 to 5, 1 being the best condition. As well as U, upgradeable',
      },
      body_type: {
        type: 'array',
        items: { type: 'string' },
        description:
          'Allows filtering based on the shape or design of a vehicle, such as coupe, SUV, hatchback, etc.',
      },
      cap_database: {
        type: 'string',
        description: 'Filters vehicles by CAP database type, such as car or LCV.',
      },
      cap_price_from: {
        type: 'number',
        description: 'Sets a minimum CAP price limit.',
      },
      cap_price_to: {
        type: 'number',
        description: 'Sets a maximum CAP price limit.',
      },
      doors: {
        type: 'array',
        items: { type: 'string' },
        description:
          'Lets users select vehicles based on the number of doors, such as 2-door, 4-door, etc.',
      },
      ending_soon: {
        type: 'boolean',
        description: 'Filter to vehicles coming to the end of their cascade.',
      },
      engine_size_from: {
        type: 'string',
        description: 'Sets a minimum engine size limit.',
      },
      engine_size_to: {
        type: 'string',
        description: 'Sets a maximum engine size limit.',
      },
      fuel_type: {
        type: 'array',
        items: { type: 'string' },
        description:
          'Allows users to select vehicles based on their fuel source, such as petrol, diesel, electric, hybrid, etc.',
      },
      gearbox: {
        type: 'array',
        items: { type: 'string' },
        description:
          'Filters vehicles by their transmission type, like manual, automatic, or semi-automatic.',
      },
      keepers_count: {
        type: 'number',
        description: 'Sets a maximum number of previous owners',
      },
      make: {
        type: 'array',
        items: { type: 'string' },
        description:
          'Refers to the brand or manufacturer of the vehicle. Examples include Ford, Toyota, BMW, etc.',
      },
      model: {
        type: 'array',
        items: { type: 'string' },
        description:
          "Specifies a particular design or version under a vehicle make. For instance, under the make 'Toyota', models might include 'Camry', 'Corolla', etc.",
      },
      mileage_from: {
        type: 'number',
        description: 'Sets a minimum mileage limit.',
      },
      mileage_to: {
        type: 'number',
        description: 'Sets a maximum mileage limit.',
      },
      mot: {
        type: 'array',
        items: { type: 'string' },
        description:
          'Include vehicles with MOTs expiring in the next 2 weeks and/or already expired',
      },
      northern_ireland: {
        type: 'boolean',
        description: 'Filter to vehicles in Northern Island only, England only or both.',
      },
      variant: {
        type: 'array',
        items: { type: 'string' },
        description:
          'Indicates a specific version or configuration of a vehicle model. Variants often denote differences in engine size, features, or trim levels.',
      },
      price_from: {
        type: 'number',
        description:
          'Sets a minimum price limit, filtering out listings below the specified price.',
      },
      price_to: {
        type: 'number',
        description:
          'Sets a maximum price limit, filtering out listings above the specified price.',
      },
      registration: {
        type: 'string',
        description: 'Filter by vehicle registration',
      },
      seats: {
        type: 'array',
        items: { type: 'string' },
        description:
          'Filters listings based on the number of seats in the vehicle, indicating its passenger capacity.',
      },
      sold_as_seen: {
        type: 'boolean',
        description: 'Show vehicle marked as sold as seen',
      },
      vat_status: {
        type: 'string',
        description: 'Show VAT exempt vehicles',
      },
      v5: {
        type: 'boolean',
        description: 'Show vehicles sold without a V5 document',
      },
      year_from: {
        type: 'number',
        description:
          'Filters vehicles based on a starting manufacture year, ensuring listings are of a certain age or newer.',
      },
      year_to: {
        type: 'number',
        description:
          'Filters vehicles up to a specified manufacture year, ensuring listings are of a certain age or older.',
      },
    },
  }),
};
